import { createFileRoute } from "@tanstack/react-router";
import { PortfolioLayout } from "#/features/portfolio/components/portfolio-layout";

export const Route = createFileRoute("/_app/portfolio")({
	component: PortfolioLayout,
});
